export const waterShortDescription = "Water extracted from Ordnance survey.";
